import { Action } from 'redux';

// TODO use discriminated union types for pattern matching in reducers instead
export function isActionFactory<T extends Action>(type: string) {
  return (action: Action): action is T => (action && action.type === type);
}
